import ImagePrint from './ImagePrint';

export default ImagePrint;
